<template>
  <div 
  v-bind:class="{menuVisible: isMenuActive}" 
  class="cameras">

    <!-- Header -->
    <div class="header">

      <!-- Menu button -->
      <div 
      v-bind:class="{active: isMenuActive}" 
      v-on:click="onClickMenu()" 
      class="menu-btn" ontouchstart="">
        <div class="bar first">&nbsp;</div>
        <div class="bar second">&nbsp;</div>
        <div class="bar third">&nbsp;</div>
        <div class="bar fourth">&nbsp;</div>
      </div><!-- Menu button -->

      <!-- Menu title -->
      <div 
      v-if="currentSiteId"
      class="header-title">
        {{currentSite.localTimeNow().toLocaleTimeString()}}
      </div><!-- Menu title -->

      <!-- Menu button -->
      <div class="option-btns">
        <div 
        v-on:click="onClickZoomOut()"
        v-bind:class="{
          'disabled': snapshotMaxWidthIndexInUse <= 0
        }"
        class="option-btn" ontouchstart="">
          <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"/>
          </svg>
        </div>
        <div 
        v-on:click="onClickZoomIn()"
        v-bind:class="{
          'disabled': snapshotMaxWidthIndexInUse >= snapshotMaxWidthSizes.length - 1
        }"
        class="option-btn" ontouchstart="">
          <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>
          </svg>
        </div>
      </div><!-- Menu button -->

    </div><!-- Header -->

    <!-- Body -->
    <div class="body">
    
      <!-- Cameras container -->
      <div 
      v-if="currentSiteId"
      class="cameras-container">

        <transition name="moveup" mode="out-in" appear>
        <span v-if="currentSite.cameras">
          <!-- Camera container -->
          <div
          v-for="cameraId in currentSite.cameras" 
          v-bind:key="cameraId"
          v-on:click="onClickCamera(cameraId)"
          v-bind:style="{'max-width': snapshotMaxWidthSizes[snapshotMaxWidthIndexInUse] + 'px'}"
          v-bind:class="{'has-event': cameraIdsWithEvents[cameraId]}"
          class="camera-container">

            <!-- 16:9 content -->
            <div class="content">

              <!-- Header - camera info -->
              <div class="camera-info">

                <div class="camera-name prevent-text-overflow">
                  <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
                  </svg>
                  {{camera(cameraId).name}}
                </div>

                <!-- Header - Online -->
                <div 
                v-if="camera(cameraId).isOnline"
                class="updated-info">
                  <div class="updated-info-description">
                    Last updated
                  </div>
                  <div class="updated-info-time">
                    {{liveSnapshot(cameraId) ? currentSite.convertToLocalTime(liveSnapshot(cameraId).timestamp).toLocaleTimeString() : 
                    statusGetLiveSnapshot(cameraId) === 'requested' ? 'loading...' : 'no info'}}
                  </div>
                </div><!-- Header - Online -->

                <!-- Header - Offline -->
                <div 
                v-else
                class="updated-info">
                  <div class="updated-info-description">
                    Status
                  </div>
                  <div class="updated-info-time">
                    Offline
                  </div>
                </div><!-- Header - Offline -->

              </div><!-- Header - camera info -->

              <!-- Body - Offline -->
              <div 
              v-if="!camera(cameraId).isOnline"
              class="svg-icon">
                <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
                  <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/>
                </svg>
              </div><!-- Body - Offline -->

              <!-- Body - Online - Image -->
              <img 
              v-if="camera(cameraId).isOnline && liveSnapshot(cameraId)"
              v-bind:src="liveSnapshot(cameraId).url"><!-- Body - Online - Image -->

              <!-- Body - Online/Offline - Recording -->
              <div v-if="camera(cameraId).isContinuousRecordingEnabled"
              v-bind:class="{'inactive': !camera(cameraId).isOnline}"
              class="recording-dot">REC</div><!-- Body - Online/Offline - Recording -->

              <!-- Body - Online - Old snapshot -->
              <div v-if="camera(cameraId).isOnline && liveSnapshot(cameraId)"
              v-bind:class="{'visible': nowTimestamp - liveSnapshot(cameraId).timestamp > 1000 * 60}"
              class="old-snapshot-overlay">Old snapshot</div><!-- Body - Online - Old snapshot -->
              

            </div><!-- 16:9 content -->

          </div><!-- Camera container -->
        </span>
        </transition>
        
      </div><!-- Cameras container -->

    </div><!-- Body -->

  </div>
</template>

<script>
import env from '../services/environment'
import device from '../api/device'

export default {
  name: 'cameras',
  created: function () {
    this.startRefreshingSiteLiveSnapshots()
    this.initializeConfigurations()
  },
  destroyed: function () {
    this.stopRefreshingSiteLiveSnapshots()
  },
  data: function () {
    return {
      cameraIdsWithEvents: {},
      refreshingSiteLiveSnapshot$i: null,
      snapshotMaxWidthSizes: [200, 300, 400, 500, 600, 700, 800],
      snapshotMaxWidthIndexInUse: null
    }
  },
  computed: {
    nowTimestamp: function () {
      return (new Date()).getTime()
    },
    isMenuActive: function () {
      return this.$store.getters.isMenuActive
    },
    currentSiteId: function () {
      return this.$store.getters.currentSiteId
    },
    currentSite: function () {
      return this.$store.getters.currentSite
    },
    lastEventId: function () {
      return this.$store.getters.lastEventId
    },
    lastEvent: function () {
      return this.$store.getters.lastEvent
    },
    event: function () {
      return this.$store.getters.event
    },
    camera: function () {
      return this.$store.getters.camera
    },
    statusGetLiveSnapshot: function () {
      return this.$store.getters.statusGetLiveSnapshot
    },
    liveSnapshot: function () {
      return this.$store.getters.liveSnapshot
    }
  },
  watch: {
    lastEventId: function (now, before) {
      this.onNewEvent(now)
    }
  },
  methods: {
    test: function () {
      // device.updateFactoryMac()
      console.log(device)
    },
    onNewEvent: function (eventId) {
      this.cameraIdsWithEvents[this.event(eventId).cameraId] = true
    },
    initializeConfigurations: function () {
      if (env.getCamerasLastZoomIndex() !== null) this.snapshotMaxWidthIndexInUse = env.getCamerasLastZoomIndex()
      else this.snapshotMaxWidthIndexInUse = this.snapshotMaxWidthSizes.length - 1
    },
    onClickZoomIn: function () {
      if (this.snapshotMaxWidthSizes.length - 1 > this.snapshotMaxWidthIndexInUse) {
        this.snapshotMaxWidthIndexInUse++
        env.setCamerasLastZoomIndex(this.snapshotMaxWidthIndexInUse)
      }
    },
    onClickZoomOut: function () {
      if (this.snapshotMaxWidthIndexInUse > 0) {
        this.snapshotMaxWidthIndexInUse--
        env.setCamerasLastZoomIndex(this.snapshotMaxWidthIndexInUse)
      }
    },
    onClickCamera: function (cameraId) {
      this.selectCamera(cameraId)
      this.$router.push({name: 'camera', params: { cameraId: cameraId }})
    },
    selectCamera: function (cameraId) {
      this.$store.dispatch('selectCamera', cameraId)
    },
    onClickMenu: function () {
      if (this.isMenuActive) this.$store.commit('CLOSE_MENU')
      else this.$store.commit('OPEN_MENU')
    },
    startRefreshingSiteLiveSnapshots: function () {
      let refreshInterval = 1000 * 5 // 5 sec
      this.stopRefreshingSiteLiveSnapshots()
      setTimeout(() => { this.getSiteLiveSnapshots() }, 1000)
      this.refreshingSiteLiveSnapshot$i = setInterval(() => {
        this.getSiteLiveSnapshots()
      }, refreshInterval)
    },
    stopRefreshingSiteLiveSnapshots: function () {
      if (this.refreshingSiteLiveSnapshot$i) {
        clearInterval(this.refreshingSiteLiveSnapshot$i)
        this.refreshingSiteLiveSnapshot$i = null
      }
    },
    getSiteLiveSnapshots: function () {
      if (this.currentSite) {
        if (this.currentSite.cameras) {
          this.currentSite.cameras.map(cameraId => {
            if (
              this.camera(cameraId).isOnline &&
              this.statusGetLiveSnapshot(cameraId) !== 'requested'
            ) {
              this.$store.dispatch('getLiveSnapshot', cameraId)
            }
          })
        }
      }
    }
  }
}
</script>

<style>
  .cameras {
    font-size: 16px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    transform: scale(1);
    transition: transform .3s;
  }
  .cameras.menuVisible {
    transform: scale(0.95);
    box-shadow: 1px 1px 8px #000;
  }


  .cameras .header {
    position: absolute;
    top: 0;
    width: 100%;
    height: 3rem;
    z-index: 100;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    color: #000;
    background-color: rgba(255,255,255,0.35);
  }
  .cameras .header .header-title {
    width: calc(100% - 40px - 80px - 1rem);
    padding-left: 40px;
    text-align: center;
    position: relative;
    background: transparent;
    z-index: 0;
  }
  .cameras .header .menu-btn{
    width: 40px;
    height: 40px;
    cursor: pointer;
    position: relative;
    margin-left: 0.5rem;
  }
  .cameras .header .menu-btn .bar{
    position: absolute;
    height: 2px;
    width: 22px;
    left: 9px;
    background-color: #000;
    transition: transform .5s, opacity .3s;
  }
  .cameras .header .menu-btn .bar.first{
    top: 13px;
  }
  .cameras .header .menu-btn .bar.second{
    top: 19px;
  }
  .cameras .header .menu-btn .bar.third{
    top: 19px;
  }
  .cameras .header .menu-btn .bar.fourth{
    top: 25px;
  }
  .cameras .header .menu-btn.active .bar.first{
    opacity: 0;
  }
  .cameras .header .menu-btn.active .bar.second{
    transform: rotate(135deg);
  }
  .cameras .header .menu-btn.active .bar.third{
    transform: rotate(-135deg);
  }
  .cameras .header .menu-btn.active .bar.fourth{
    opacity: 0;
  }

  .cameras .header .option-btns{
    width: 80px;
    height: 40px;
    position: relative;
    display: flex;
    margin-right: 0.5rem;
  }
  .cameras .header .option-btns .option-btn{
    width: 40px;
    height: 40px;
    cursor: pointer;
    position: relative;
    opacity: 0.9;
    transition: opacity .3s, color .3s;
  }
  .cameras .header .option-btns .option-btn:hover{
    color: hsl(210, 100%, 40%);
  }
  .cameras .header .option-btns .option-btn.disabled{
    pointer-events: none;
    opacity: 0.2;
  }
  .cameras .header .option-btns .option-btn.disabled:hover{
    opacity: 0.2;
  }
  .cameras .header .option-btns .option-btn > svg{
    fill: currentColor;
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }


  .cameras .body {
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .cameras .body .cameras-container {
    padding: 0;
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: ms-autohiding-scrollbar;
  }
  .cameras .body .cameras-container::-webkit-scrollbar {
    display: none;
  } 
  .cameras .body .cameras-container > span {
    padding: 0;
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .cameras .body .cameras-container > span:before {
    content: ' ';
    height: 100px;
    width: 100%;
  }
  .cameras .body .cameras-container > span:after {
    content: ' ';
    height: 80px;
    width: 100%;
  }
  .cameras .body .cameras-container .camera-container {
    width: 100%;
    max-width: 600px;
    margin: 6px;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.5);  
    border-top: 3rem solid #fff;
    position: relative;
    background-color: #222;
    color: #fff;
    cursor: pointer;
    outline: 0px solid hsl(20, 100%, 50%);
    transition: max-width .3s, outline .3s;
  }
  .cameras .body .cameras-container .camera-container.has-event {
    /* outline: 4px solid hsl(20, 100%, 50%); */
    outline: 4px solid hsl(200, 75%, 50%);
  }
  .cameras .body .cameras-container .camera-container.selected {
    outline: 4px solid hsl(200, 75%, 50%);
  }


  .cameras .body .camera-container {
    width: 100%;
    position: relative;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.5);
    background-color: #222;
    color: #fff;
    cursor: pointer;
  }
  .cameras .body .camera-container:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: 56.25%;
  }
  .cameras .body .camera-container > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .cameras .body .camera-container img{
    width: 100%;
    height: 100%;
  }
  .cameras .body .camera-container .recording-dot{
    font-size: 10px;
    width: 3em;
    height: 3em;
    background-color: hsla(0, 100%, 50%, 1);
    box-shadow: 0 0 4px #000;
    right: 0.5em;
    top: 0.5em;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    position: absolute;
  }
  .cameras .body .camera-container .recording-dot.inactive{
    background-color: hsla(0, 0%, 50%, 1);
    opacity: 0.3;
  }

  .cameras .body .camera-container .old-snapshot-overlay {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.7);
  }
  .cameras .body .camera-container .old-snapshot-overlay.visible{
    display: flex;
  }

  .cameras .body .camera-container .camera-info{
    width: calc(100% - 2em);
    height: 3rem;
    font-size: 14px;
    position: absolute;
    top: -3rem;
    left: 0;
    background-color: rgba(255,255,255,0.5);
    color: #333;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 1em;
  }
  .cameras .body .camera-container .camera-info .camera-name {
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: calc(100% - 120px);
  }
  .cameras .body .camera-container .camera-info .camera-name svg {
    fill: currentColor;
    margin-right: 1em;
    width: 24px;
    height: 24px;
    display: none;
  }
  .cameras .body .camera-container .camera-info .updated-info {
    padding: 0;
    width: 90px;
    font-size: 12px;
    border-left: 1px solid #ddd;
    padding-left: 1em;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .cameras .body .camera-container .camera-info .updated-info .updated-info-description {
    opacity: 0.3;
  }
  .cameras .body .camera-container .camera-info .updated-info .updated-info-time {
    opacity: 1;
  }

</style>



// WEBPACK FOOTER //
// Cameras.vue?6a016b10